import { Cat, Dog, Rabbit, Bird, Fish, Turtle, Rocket, Star, Ghost, Squirrel } from "lucide-react";

export const AVATARS = {
  cat: { Icon: Cat, rgb: "236,72,153", label: "Cat" },
  dog: { Icon: Dog, rgb: "245,158,11", label: "Dog" },
  rabbit: { Icon: Rabbit, rgb: "139,92,246", label: "Rabbit" },
  bird: { Icon: Bird, rgb: "56,189,248", label: "Bird" },
  fish: { Icon: Fish, rgb: "6,182,212", label: "Fish" },
  turtle: { Icon: Turtle, rgb: "34,197,94", label: "Turtle" },
  rocket: { Icon: Rocket, rgb: "244,121,32", label: "Rocket" },
  star: { Icon: Star, rgb: "250,204,21", label: "Star" },
  ghost: { Icon: Ghost, rgb: "161,161,170", label: "Ghost" },
  squirrel: { Icon: Squirrel, rgb: "239,68,68", label: "Squirrel" },
};

export function KidAvatar({ avatar, size = 48, className = "" }) {
  const a = AVATARS[avatar] || AVATARS.cat;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full flex-shrink-0 ${className}`}
      style={{ width: size, height: size, background: `rgba(${a.rgb},0.16)`, boxShadow: `inset 0 0 0 1.5px rgba(${a.rgb},0.5), 0 0 18px rgba(${a.rgb},0.25)` }}
    >
      <a.Icon style={{ width: size * 0.5, height: size * 0.5, color: `rgb(${a.rgb})` }} strokeWidth={2.2} />
    </span>
  );
}

export function AdultAvatar({ name, picture, size = 40 }) {
  const init = name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0].toUpperCase()).join("");
  if (picture) return <img src={picture} alt={name} className="rounded-full object-cover flex-shrink-0" style={{ width: size, height: size }} />;
  return (
    <span className="inline-flex items-center justify-center rounded-full flex-shrink-0 font-display font-bold text-q-text"
      style={{ width: size, height: size, fontSize: size * 0.36, background: "rgba(var(--glow-family),0.14)", boxShadow: "inset 0 0 0 1px rgba(var(--glow-family),0.4)" }}>
      {init}
    </span>
  );
}
